<template>
  <!-- Main container with bottom padding for nav bar -->
  <div class="flex flex-col h-dvh bg-base-100">
    <!-- Main content area with bottom padding for nav -->
    <main class="flex-1 overflow-y-auto pb-16">
      <router-view></router-view>
    </main>

    <!-- Bottom navigation bar -->
    <nav
      class="fixed z-20 bottom-0 left-0 right-0 bg-base-100 border-t border-base-200 shadow-[0_0_15px_rgba(0,0,0,0.1)]"
    >
      <div class="flex justify-around items-center h-16">
        <router-link
          v-for="item in menuItems"
          :key="item.path"
          :to="item.path"
          class="flex flex-col items-center justify-center w-full h-full"
          :class="{ 'text-primary font-medium': isCurrentRoute(item.path) }"
        >
          <!-- Icon for each menu item -->
          <DefaultIcon
            :name="item.icon"
            size="w-6 h-6"
            :color="isCurrentRoute(item.path) ? '#673ab7' : undefined"
          />

          <!-- Label for each menu item -->
          <span class="text-xs mt-1">{{ item.name }}</span>
        </router-link>
      </div>
    </nav>
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import DefaultIcon from "@/components/icons/DefaultIcon.vue";

const route = useRoute();

// Update menu items for driver interface
const menuItems = [
  { name: "Kelionės", path: "/driving/travels", icon: "plan" },
  { name: "Statistika", path: "/driving/statistics", icon: "chartBar" },
  { name: "Profilis", path: "/driving/profile", icon: "users" },
];

// Helper function to check if route is active
const isCurrentRoute = (path) => {
  return route.path === path || route.path.startsWith(path + "/");
};
</script>
